import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import Icon from '@/components/renewal/common/icon.vue';
import { useStore } from '@/store/useStore';
import { useAuth } from '@/plugins/auth';
import { QuestionBytesLimit } from '@/constants';
import { handleWandhEnterKey, handleKeywordEnterKey } from '@/utils/keyboardUtils';
export default /*#__PURE__*/_defineComponent({
  __name: 'search-form',
  props: {
    inputSearchKeyword: null,
    isKeywordAskable: {
      type: Boolean
    },
    searchConditions: null
  },
  emits: ["update:inputSearchKeyword", "changeType", "changeShowFilter", "submit"],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var auth = useAuth();
    var store = useStore();
    var wandhForm = ref(null);
    var keywordForm = ref(null);

    // 可変行数機能のためのスタイル
    var wandhFormStyle = ref({
      height: 'auto'
    });

    // Watson & Holmes を利用できない
    var disableWandh = computed(function () {
      return !(auth.permissions.labsQA || auth.permissions.labsQAWatson);
    });
    var wandhQuestion = computed({
      get: function get() {
        return store.state.persistent.labs.wandh.inputQuery.question;
      },
      set: function set(newVal) {
        store.commit('setLabsWandhInputQuery', _objectSpread(_objectSpread({}, store.state.persistent.labs.wandh.inputQuery), {}, {
          question: newVal
        }));
      }
    });
    var wandhQuestionBytes = computed(function () {
      return new TextEncoder().encode(wandhQuestion.value.trim()).length;
    });
    var handleWandhInput = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var target;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              target = event.target; // scrollHeightを正しく取得するために一度height: auto;にする
              wandhFormStyle.value.height = 'auto';

              // height: auto;が反映されるまで待つ
              _context.next = 4;
              return nextTick();
            case 4:
              wandhFormStyle.value.height = "".concat(target.scrollHeight, "px");
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleWandhInput(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleClickWandh = function handleClickWandh() {
      var _wandhForm$value;
      emit('changeType', 'wandh');
      (_wandhForm$value = wandhForm.value) === null || _wandhForm$value === void 0 ? void 0 : _wandhForm$value.focus();
    };
    var handleClickKeyword = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _keywordForm$value;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              emit('changeType', 'keyword');

              // NOTE: 検索条件(searchConditions)が表示されているときにクリックされるとフォーカスされないことがあるためnextTickで少し待機する
              _context2.next = 3;
              return nextTick();
            case 3:
              (_keywordForm$value = keywordForm.value) === null || _keywordForm$value === void 0 ? void 0 : _keywordForm$value.focus();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleClickKeyword() {
        return _ref3.apply(this, arguments);
      };
    }();
    var handleClickFilterOpen = function handleClickFilterOpen() {
      emit('changeShowFilter', true);
    };
    var handleWandhEnter = function handleWandhEnter(event) {
      handleWandhEnterKey(event, function () {
        return emit('submit');
      });
    };
    var handleKeywordEnter = function handleKeywordEnter(event) {
      handleKeywordEnterKey(event, function () {
        return emit('submit');
      });
    };
    var submit = function submit() {
      emit('submit');
    };
    var handleKeywordInput = function handleKeywordInput(event) {
      emit('update:inputSearchKeyword', event.target.value);
    };
    var isWandhQuestionValid = computed(function () {
      return (
        // 質問が入力されている
        wandhQuestionBytes.value > 0 &&
        // 質問が文字数制限内
        wandhQuestionBytes.value <= QuestionBytesLimit
        // 期間指定がされている。未入力は undefined, 空にすると '' になる
      );
    });
    expose({
      isWandhQuestionValid: isWandhQuestionValid
    });
    return {
      __sfc: true,
      emit: emit,
      auth: auth,
      store: store,
      wandhForm: wandhForm,
      keywordForm: keywordForm,
      wandhFormStyle: wandhFormStyle,
      disableWandh: disableWandh,
      wandhQuestion: wandhQuestion,
      wandhQuestionBytes: wandhQuestionBytes,
      handleWandhInput: handleWandhInput,
      handleClickWandh: handleClickWandh,
      handleClickKeyword: handleClickKeyword,
      handleClickFilterOpen: handleClickFilterOpen,
      handleWandhEnter: handleWandhEnter,
      handleKeywordEnter: handleKeywordEnter,
      submit: submit,
      handleKeywordInput: handleKeywordInput,
      isWandhQuestionValid: isWandhQuestionValid,
      Icon: Icon
    };
  }
});